import { render, staticRenderFns } from "./VCoachForm.vue?vue&type=template&id=6b06ee78&scoped=true"
import script from "./VCoachForm.vue?vue&type=script&lang=js"
export * from "./VCoachForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b06ee78",
  null
  
)

export default component.exports